import axios from "axios";
import {
  GET_APP_TRACK_LIST_FAIL,
  GET_APP_TRACK_LIST_REQUEST,
  GET_APP_TRACK_LIST_SUCCESS,
  GET_APP_TRACK_BY_DATE_LIST_FAIL,
  GET_APP_TRACK_BY_DATE_LIST_REQUEST,
  GET_APP_TRACK_BY_DATE_LIST_SUCCESS,
} from "../../types/user/appTrackTypes";
//import moment from "moment";
import dayjs from "dayjs";

//Get App Track Of User
export const userAppTrackAction = (companyId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_APP_TRACK_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let body = {
      date: dayjs(new Date()).format("YYYY-MM-DD"),
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/app/date`,
      body,
      config
    );
    dispatch({
      type: GET_APP_TRACK_LIST_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: GET_APP_TRACK_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Get App Track Of User
export const userAppTrackByDateAction =
  (companyId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_APP_TRACK_BY_DATE_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let body = {
        date: dayjs(date).format("YYYY-MM-DD"),
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/app/date`,
        body,
        config
      );
      dispatch({
        type: GET_APP_TRACK_BY_DATE_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: GET_APP_TRACK_BY_DATE_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
